<template>
<div>
  <div class="d-flex flex-column align-items-center mt-3">
    <img width="52px" height="55px" class="m-1" src="../assets/images/icon-temoignage@3x.png" alt="image"/>
    <div style="height: 0.3rem; width: 7rem" class="bg-primary mt-1"></div>
    <h2 class="font-weight-bold">Témoignages</h2>
    <div class="row w-100">
      <div class="col-1 offset-1 d-flex align-items-center justify-content-center">
        <img class="temoignage_btn" id="temoignage_btn_left" v-on:click="scrollTemoignage('left')" src="../assets/images/temoignage_btn_left.png" height="39px"/>
      </div>
      <div class="temoignage_container d-flex col-8">
        <div class="temoignage" v-for="temoignage in temoignages" :key="temoignage.titre" @click="showTemoignageModal(temoignage)">
          <div class="mb-3 d-flex text-center flex-grow-1 overflow-hidden" v-html=" temoignage.texte "></div>
          <div style="height: 0.3rem; width: 7rem" class="bg-primary"></div>
          <div class="text-primary text-uppercase" v-html=" temoignage.titre "></div>
        </div>
      </div>
      <div class="col-1 d-flex align-items-center justify-content-center">
        <img class="temoignage_btn" id="temoignage_btn_right" v-on:click="scrollTemoignage('right')" src="../assets/images/temoignage_btn_right.png" height="39px"/>
      </div>
    </div>
  </div>
  <b-modal hide-footer
        centered
        size="sm"
        content-class="temoignage_modal"
        id="temoignageModal">
    <template #modal-title>
      <div style="height: 0.3rem; width: 7rem" class="bg-primary"></div>
      <div class="text-primary text-uppercase" v-html=" temoignageToFocus.titre "></div>
    </template>
    <div class="mb-3 d-flex text-center flex-grow-1 overflow-hidden" v-html=" temoignageToFocus.texte "></div>
  </b-modal>
</div>
</template>

<script>
import DataApi from 'fm-data-api'

export default {
  name: 'Temoignage',
  components: {
  },
  data: function () {
    return {
      temoignages: [],
      temoignageToFocus: {}
    }
  },
  methods: {
    async getTemoignage () {
      const options = {
        apiUrl: this.$apiUrl,
        databaseName: this.$databaseName,
        token: await this.$getMainToken()
      }
      this.dataApi = new DataApi(options)
      return await this.dataApi.findRecords('W_Focus', { 'foc_RBQ__Rubrique::d_nomRubrique': 'Financement immobilier et professionnels', 'foc_rbq_SOC__Societe::d_nomSociete': 'CG Courtage', d_type: 'témoignage' }, '', '', '30')
        .then((focusList) => {
          const temoignages = []
          focusList.forEach(function (focus) {
            temoignages.push({
              titre: focus.fieldData.d_titre,
              texte: focus.fieldData.d_texte,
              theme: focus.fieldData.d_theme,
              image: focus.fieldData['foc_PHOP__PhotoPrincipale::d_image'],
              type: 'témoignage'
            })
          })
          return temoignages
        })
    },
    scrollTemoignage (direction) {
      this.sideScroll(
        document.getElementsByClassName('temoignage_container')[0], direction, 10, 300, 10)
    },
    sideScroll (element, direction, speed, distance, step) {
      let scrollAmount = 0
      var slideTimer = setInterval(
        function () {
          if (direction === 'left') {
            element.scrollLeft -= step
          } else {
            element.scrollLeft += step
          }
          scrollAmount += step
          if (scrollAmount >= distance) {
            window.clearInterval(slideTimer)
          }
        }, speed)
    },
    showTemoignageModal (temoignage) {
      this.temoignageToFocus = temoignage
      this.$bvModal.show('temoignageModal')
    }
  },
  async beforeMount () {
    await this.getTemoignage()
      .then(res => {
        this.temoignages = res
      })
  }
}
</script>

<style lang="scss">
.temoignage {
  background-image: url("../assets/images/temoignage_bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  height: 280px;
  width: 280px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: white;
  margin: 10px;
  padding: 60px;
  flex-shrink: 0;
  cursor: pointer;
}
.temoignage_container {
  overflow: hidden;
}
.temoignage_btn:hover {
  filter: opacity(25%);
  cursor: pointer;
}
.temoignage_modal {
  background: #373737;
  color: white
}
</style>
